export const KEYFRAME_PROPS = ['x', 'y', 'width', 'height', 'rotation']
